"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Twitter, ArrowUp, MapPin, Phone, Mail, Sun } from "lucide-react";
const services = ["Solar Panel Cleaning", "Residential Solar Cleaning", "Commercial Solar Cleaning", "Bird Dropping / Debris Removal", "Panel Inspection"];
function FooterLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted-foreground/20 animate-pulse rounded" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        {["Home", "About Us", "Services", "Contact"].map((item, i) => <li key={i} data-index={i}>
            <Link to="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              {item}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function FooterInformation() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const currentYear = new Date().getFullYear();
  return <section id="footer-information" className="bg-muted pt-16 pb-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 rounded-full blur-3xl pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <img src="https://brief-horse.websiteshop.au/wp-content/uploads/2026/03/Power-Shine-Solar-2.png" alt="Power Shine Solar Cleaning" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed mb-6">
              Professional solar panel cleaning services dedicated to improving efficiency and keeping your solar system performing at its absolute best. Safe, reliable, and fully insured.
            </p>
            <div className="flex items-center gap-2 text-primary font-medium text-sm bg-primary/10 px-3 py-1.5 rounded-full">
              <Sun className="size-4" />
              <span>Maximize Your Solar Output</span>
            </div>
          </div>

          {}
          <div>
            <h3 className="font-semibold text-foreground mb-6 text-lg">Quick Links</h3>
            <MenuProvider menu_id="3">
              <FooterLinks />
            </MenuProvider>
          </div>

          {}
          

          {}
          <div>
            <h3 className="font-semibold text-foreground mb-6 text-lg">Contact Us</h3>
            <ul className="space-y-4 mb-6">
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="size-4 text-primary shrink-0 mt-0.5" />
                <span>Central Coast, NSW, Australia</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="size-4 text-primary shrink-0" />
                <Link to="tel:0466880255" className="hover:text-primary transition-colors">
                  0466 880 255
                </Link>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="size-4 text-primary shrink-0" />
                <Link to="mailto:sales@powershine.com.au" className="hover:text-primary transition-colors">sales@powershine.com.au</Link>
              </li>
            </ul>
            
            
          </div>

        </div>

        <Separator className="bg-border/60 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground text-center md:text-left">&copy; 2026 Power Shine Solar Cleaning. All rights reserved. 2026 Website Build by <Link to="https://www.websiteshop.com.au" newTab className="text-[#0062a4] hover:underline transition-colors">Website Shop</Link></p>
          
          <div className="flex items-center gap-4">
            
            
            <Button variant="secondary" size="icon" onClick={scrollToTop} className="rounded-full ml-4 shadow-sm hover:shadow-md transition-all" title="Back to top">
              <ArrowUp className="size-4" />
              <span className="sr-only">Back to top</span>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}